import { css } from 'jimu-core';
export const formFeedbackStyles = (props) => {
    var _a, _b, _c, _d, _e;
    const theme = props.theme;
    const valid = props.valid;
    const shouldDisplay = valid !== undefined;
    const formVars = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.form;
    // TODO: add theme variables for font size
    return formVars && css `
    display: ${shouldDisplay ? 'block' : 'none'};
    width: 100%;
    margin-top: ${formVars.helpText && formVars.helpText.marginTop};
    font-size: ${formVars.helpText && formVars.helpText.fontSize};
    ${shouldDisplay && css `
      color: ${valid && ((_c = (_b = theme.sys.color) === null || _b === void 0 ? void 0 : _b.success.main) !== null && _c !== void 0 ? _c : 'green')};
      color: ${!valid && ((_e = (_d = theme.sys.color) === null || _d === void 0 ? void 0 : _d.error.main) !== null && _e !== void 0 ? _e : 'red')};
    `}
  `;
};
